import { useFreshData } from "@store/hooks";
import { useCaptureUtmParams } from "@store/hooks/useCaptureUtm";
import { signIn, useSession } from "next-auth/react";
import { useEffect } from "react";

// Component wrapper for all routes when all providers are loaded
export default function RootComponentWrapper({ children }) {
    const { data: session, status } = useSession();
    useCaptureUtmParams();
    useFreshData();
    useEffect(() => {
        // User has no session at all. Sign in as anonymous user so we can access CommerceTools.
        if (status === "unauthenticated" && !session) {
            signIn("anonymous", { redirect: false });
        }
    }, [session, status]);

    return <>{children}</>;
}
